import { useEffect, useState } from 'react'

const breakpoints = {
  'sm': 640,
  'md': 768,
  'lg': 1024,
  'xl': 1280,
  '2xl': 1536,
}

interface Breakpoints {
  'sm': boolean
  'md': boolean
  'lg': boolean
  'xl': boolean
  '2xl': boolean
  'base': boolean
}

function getBreakpoints(width: number) {
  return {
    'sm': width >= breakpoints.sm,
    'md': width >= breakpoints.md,
    'lg': width >= breakpoints.lg,
    'xl': width >= breakpoints.xl,
    '2xl': width >= breakpoints['2xl'],
    'base': width < breakpoints.sm,
  }
}

export function useBreakpoints() {
  const [breakpointsState, setBreakpointsState] = useState<Breakpoints>(() => getBreakpoints(0))

  useEffect(() => {
    const onResize = () => {
      setBreakpointsState(getBreakpoints(window.innerWidth))
    }

    onResize()
    window.addEventListener('resize', onResize)

    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  return breakpointsState
}
